      <template>
          <DashboardCard header-title="Partner Report"
                      :refreshButton="true"
                      @refresh="resetForm(true)">
              
              <!-- TABLE -->
              <PaginatedTable
                  :table-data="tableData"
                  :table-headers="tableHeaders"
                  :extra-inputs="extraInputs"
                  :searchModel="searchModel"
                  :paginated="true"
                  :showElementsPerPage="true"
                  :date-search="false"
                  searchQueryPlaceholder="Search Partner Name..."
                  @search="makeSearch"
                @sort="handleSort"
                  @next="(p)=>loadPage(true,p)"
                  @previous="(p)=>loadPage(false,p)"
              >

                  <!-- SLOT MUST BE INSIDE THIS TAG -->
          <template #below-search>
              <div class="row p-3 mb-3" style="background:#f7f7f7; border-radius:8px;">
                  <h5 class="mb-3 fw-bold">Select Report Fields</h5>

                  <div class="row">
                      <div class="col-md-3 mb-2"
                          v-for="field in availableFields"
                          :key="field.key">
<div class="d-flex align-items-center">

    <Checkbox
        v-model="selectedFields"
        :inputId="field.key"
        :value="field.key"
    />

    <label
        class="form-check-label ms-2"
        :for="field.key"
    >
        {{ field.label }}
    </label>

</div>

                      </div>
                  </div>
              </div>
          </template>

      </PaginatedTable>

          </DashboardCard>

          <!-- 🔹 PRINTABLE PDF CONTAINER -->
  <div class="d-none" :id="reportPageId">
    <div :style="page">

      <!-- HEADER -->
    <div :style="pageHeader">

    <div style="width:25%; padding:10px;">
      <strong>{{ loggedInUser?.username ? loggedInUser.username.toUpperCase() : '-' }}</strong>
    </div>

    <div style="width:50%; text-align:center; padding:10px;">
      <h4 style="margin-bottom:0;">
        {{ institution?.name ? institution.name.toUpperCase() : '-' }}
      </h4>
      <div style="font-weight:bold;">PARTNER REPORT</div>
    </div>

    <div style="width:25%; text-align:right; padding:10px;">
      {{ new Date().toLocaleDateString() }}
    </div>

  </div>

      <!-- TABLE -->
      <PaginatedTable
        :table-data="allTableData"
        :table-headers="pdfTableHeaders"
        :tablePrintable="true"
        :paginated="true"
      />

    </div>
  </div>


          <!-- BUTTONS -->
          <div class="row pt-3 px-3" v-if="tableData.totalElements > 0">

              <div :class="exportable ? 'col-md-6 mb-3' : 'col-md-12 mb-3'">
                  <Button :label="printButtonLabel" icon="pi pi-print" class="w-100"
                      @click="makePdf" />
              </div>

              <div class="col-md-6 mb-3" v-if="exportable">
                  <Button label="Export Excel" icon="pi pi-file-export" severity="danger"
                      class="w-100" @click="exportExcel" />
              </div>

          </div>
      </template>


      <script>
      import PaginatedTable from "@/dashboard/utils/paginator/PaginatedTable.vue";
      import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
      import Button from "primevue/button";
      import { getCountries } from "@/dashboard/utils/countries";
      import {AVAILABLE_LANGUAGES, INDIA_STATES, SUBSCRIPTION_PLANS} from "@/dashboard/organization/Organization";
import Checkbox from "primevue/checkbox";
    import { MEMBERSHIP_DURATIONS } from "@/dashboard/members/members";

  // 🔹 ADD HERE (top of script)
  const DEFAULT_FIELDS = [
    "code",
    //"fullName",
    //"phone",
    //"subscription",
    //"district",
    //"creationDate"   
  ];


      export default {
          name: "PartnerReport",

         components: {
    PaginatedTable,
    DashboardCard,
    Button,
    Checkbox
},

          data() {
    return {
      searchModel: {
        query: null,
        partnerCodes: null,
        phone: null,
        phoneCode: 91,
        alternatePhone: null,
        alternatePhoneCode: 91,
        countries: [],      
    states: [],        
    state: null,        

        country: null,
        pincode: null,
        district: null,
        languages: [],
        active: null,
        creationDateIn: "TODAY",
        page: 1,
        size: 10,
        
        
        
      
      },
  categoryMap: {},
      availableFields: [
        { key: "code", label: "Partner Code" },
        { key: "fullName", label: "Partner Name" },
        //added date is  04/06/2026
       // key: "phoneCode", label: "Phone Code" },
        { key: "phone", label: "Phone" },
        //added date is 04/06/2026
        //key: "whatsappCode", label: "WhatsApp Code" },
        { key: "whatsapp", label: "WhatsApp" },
        //added date is 04/06/2026
      //{ key: "alternatePhoneCode", label: "Alternative Phone Code" },
        { key: "alternatePhone", label: "Alternate Phone" },
        { key: "gender", label: "Gender" },
        { key: "email", label: "Email" },
        { key: "subscription", label: "Subscription" },
        { key: "categories", label: "Category" },
        { key: "district", label: "District" },
        { key: "creationDate", label: "Created On" },
        { key: "pincode", label: "Pincode" },
        { key: "address1", label: "Address Line 1" },
        { key: "address2", label: "Address Line 2" },
        { key: "address3", label: "Address Line 3" },
        { key: "country", label: "Country" },
        { key: "state", label: "State" },
        { key: "dob", label: "Date of Birth" },
        { key: "dom", label: "Date of Marriage" }
      ],

      selectedFields: [...DEFAULT_FIELDS],

      extraInputs: [
      {
    type: "MULTISELECT",
    model: "countries",
    placeholder: "Country",
    styleClass: "col-md-4 mb-3",
    options: [...getCountries()]
  },
  {
    type: "MULTISELECT",
    model: "states",
    placeholder: "States",
    styleClass: "col-md-4 mb-3",
    options: [...INDIA_STATES],
    shownIf: {
      model: "countries",
      values: ["IN"],
      exactMatch: true,
      onShowSet: { model: "state", value: null }
    }
  },
  {
    type: "TEXT",
    model: "state",
    placeholder: "State",
    styleClass: "col-md-4 mb-3",
    hiddenIf: {
      model: "countries",
      values: ["IN"],
      exactMatch: true,
      onShowSet: { model: "states", value: null }
    }
  },
        {
          type: "TEXT",
          model: "district",
          placeholder: "District",
          styleClass: "col-md-4 mb-3"
        },
        {
          type: "TEXT",
          model: "pincode",
          placeholder: "Pincode",
          styleClass: "col-md-4 mb-3"
        },
        {
          type: "MULTISELECT",
          model: "languages",
          placeholder: "Languages",
          styleClass: "col-md-4 mb-3",
          options: AVAILABLE_LANGUAGES
        },
        {
          type: "SELECT",
          model: "subscription",
          placeholder: "Subscription",
          styleClass: "col-md-4 mb-3",
          options: [
            { label: "All", value: null },
            ...SUBSCRIPTION_PLANS
          ]
        },
        {
          type: "MULTISELECT",
          model: "categories",
          placeholder: "Category",
          styleClass: "col-md-4 mb-3",
          options: []
        },
      {
    type: "SELECT",
    model: "creationDateIn",
    placeholder: "Creation Date In",
    styleClass: "col-md-4 mb-3",
    options: [...MEMBERSHIP_DURATIONS]
  },
  {
    type: "DATE",
    format: "dd/mm/yy",
    model: "from",
    placeholder: "Date From",
    styleClass: "col-md-4 mb-3",
    shownIf: { model: "creationDateIn", values: ["SINGLE_DATE", "CUSTOM_DATE_GAP"] }
  },
  {
    type: "DATE",
    format: "dd/mm/yy",
    model: "to",
    placeholder: "Date To",
    styleClass: "col-md-4 mb-3",
    shownIf: { model: "creationDateIn", values: ["CUSTOM_DATE_GAP"] }
  },
        {
          type: "TEXTAREA",
          model: "partnerCodes",
          placeholder: "Partner Codes...",
          styleClass: "col-md-12 mb-3"
        },
      {
    type: "PHONE_NUMBER",
    model: ["phoneCode", "phone"],
    styleClass: "col-md-4 mb-3",
    placeholder: "Phone Number"
  },
  {
    type: "PHONE_NUMBER",
    model: ["alternatePhoneCode", "alternatePhone"],
    styleClass: "col-md-4 mb-3",
    placeholder: "Alternate Phone Number"
  },

        {
          type: "SELECT",
          model: "active",
          placeholder: "Status",
          styleClass: "col-md-4 mb-3",
          options: [
            { label: "All", value: null },
            { label: "Active", value: true },
            { label: "Inactive", value: false }
          ]
        }
      ],

      tableData: {
        content: [],
        totalElements: 0,
        totalPages: 0,
        currentPage: 0
      },

      allTableData: {
        content: [],
        totalElements: 0,
        totalPages: 0,
        currentPage: 0
      },

      reportPageId: Math.random().toString(36).substring(2),

      page: {
        width: "100%"
      },

      pageHeader: {
        display: "flex",
        width: "100%",
        backgroundColor: "white",
        color: "#000"
      }
    };
  }
  ,

          computed: {
          exportable() {
              return this.tableData.totalElements > 0;
          },

          pdfTableHeaders() {
    return {
      "S.No": {
        rows: [{ type: "String", attribute: "serialNo" }]
      },
      ...this.tableHeaders
    };
  },

          printButtonLabel() {
              return "Export PDF";
          },
          loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },

  
    institution() {
      const user = this.$store.getters.getLoggedInUser;
      if (!user) return null;
      return user.institution || this.$store.getters.getInstitution;
    },

          tableHeaders() {
              const headerMap = {
                  code: {
                      label: "PARTNER CODE",
                      rows: [{ type: "String", attribute: "code" }]
                  },
                  fullName: {
                      label: "PARTNER NAME",
                      rows: [{ type: "String", attribute: "fullName" }]
                  },
                  //commanded date is 04/06/2026
                  /*
                  phone: {
                      label: "PHONE",
                      rows: [{ type: "PhoneNumber", attribute: ["phoneCode", "phone"] }]
                  },
                  */
//added date is 04/06/2026
phone: {
    label: "PHONE",
    rows: [{ type: "String", attribute: "phone" }]
},




//commanded date is 0406/2026
/*
whatsapp: {
    label: "WHATSAPP",
    rows: [{
        type: "PhoneNumber",
        attribute: ["whatsappNumberCode", "whatsappNumber"]
    }]
},
*/
whatsapp: {
    label: "WHATSAPP",
    rows: [{ type: "String", attribute: "whatsappNumber" }]
},

              //commanded date is 04/06/2026
                   /*
                  alternatePhone: {
                      label: "ALTERNATIVE PHONE",
                      rows: [{ type: "PhoneNumber", attribute: ["alternatePhoneCode", "alternatePhone"] }]
                  },
                  */
//added date is 04/06/2026
alternatePhone: {
    label: "ALTERNATIVE PHONE",
    rows: [{ type: "String", attribute: "alternatePhone" }]
},

                  gender: {
                      label: "GENDER",
                      rows: [{ type: "String", attribute: "gender" }]
                  },
                  email: {
                      label: "EMAIL",
                      rows: [{ type: "String", attribute: "email" }]
                  },
                  subscription: {
                      label: "SUBSCRIPTION",
                      rows: [{ type: "String", attribute: "subscription" }]
                  },
                  district: {
                      label: "DISTRICT",
                      rows: [{ type: "String", attribute: "district" }]
                  },
                  creationDate: {
      label: "CREATED ON",
      rows: [{ type: "Date", attribute: "creationDate" }]
    },
                  pincode: {
                      label: "PINCODE",
                      rows: [{ type: "String", attribute: "pincode" }]
                  },
                  country: {
                      label: "COUNTRY",
                      rows: [{ type: "String", attribute: "country" }]
                  },
                  state: {
                      label: "STATE",
                      rows: [{ type: "String", attribute: "state" }]
                  },
                  dob: {
                      label: "DOB",
                      rows: [{ type: "Date", attribute: "dob" }]
                  },
                  dom: {
                      label: "DOM",
                      rows: [{ type: "Date", attribute: "dom" }]
                  },
                  address1: {
    label: "ADDRESS LINE 1",
    rows: [{ type: "String", attribute: "addressLine1" }]
  },
  address2: {
    label: "ADDRESS LINE 2",
    rows: [{ type: "String", attribute: "addressLine2" }]
  },
  address3: {
    label: "ADDRESS LINE 3",
    rows: [{ type: "String", attribute: "addressLine3" }]
  },
              categories: {
              label: "CATEGORY",
            rows: [{ type: "String", attribute: "categories" }]
                }

                  
              };

              //commanda date is 04/06/2026
        /*
              let headers = {};

              this.selectedFields.forEach(key => {
                  if (headerMap[key]) {
                      headers[headerMap[key].label] = {
                          rows: headerMap[key].rows
                      };
                  }
              });
              */

//added date is 04/06/2026
let headers = {};

this.selectedFields.forEach(key => {

    if (key === "phone") {

        headers["PHONE CODE"] = {
            rows: [{ type: "String", attribute: "phoneCode" }]
        };

        headers["PHONE"] = {
            rows: [{ type: "String", attribute: "phone" }]
        };

        return;
    }

    if (key === "whatsapp") {

        headers["WHATSAPP CODE"] = {
            rows: [{ type: "String", attribute: "whatsappNumberCode" }]
        };

        headers["WHATSAPP"] = {
            rows: [{ type: "String", attribute: "whatsappNumber" }]
        };

        return;
    }

    if (key === "alternatePhone") {

        headers["ALTERNATIVE PHONE CODE"] = {
            rows: [{ type: "String", attribute: "alternatePhoneCode" }]
        };

        headers["ALTERNATIVE PHONE"] = {
            rows: [{ type: "String", attribute: "alternatePhone" }]
        };

        return;
    }

    if (headerMap[key]) {
        headers[headerMap[key].label] = {
            rows: headerMap[key].rows
        };
    }
});


              return headers;
          }
      },

          methods: {
   resetForm(reload = true) {

  this.searchModel = {
    query: null,
    partnerCodes: null,
    phone: null,
    phoneCode: 91,
    alternatePhone: null,
    alternatePhoneCode: 91,
    country: null,
    pincode: null,
    district: null,
    languages: [],
    active: null,
    creationDateIn: "TODAY",
    page: 1,
    size: 10
  };

  // ✅ RESET REPORT FIELD CHECKBOXES
  this.selectedFields = [...DEFAULT_FIELDS];

  this.tableData = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    currentPage: 0
  };

  if (reload) {
    this.fetchPage(this.searchModel);
  }
},

  handleSort(newContent) {

    // reset serial numbers after sorting
    const updated = newContent.content.map((row, index) => ({
      ...row,
      serialNo: index + 1
    }));

    this.tableData = {
      ...newContent,
      content: updated
    };
  },

  getTodayForFileName() {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    return `${dd}-${mm}-${yyyy}`; // 07-02-2026
  },


            loadCategories() {
    const body = this.$root.addInstitutionId({});

    this.$api.post("/category/get", body).then(res => {

      // 🔹 Build ID → NAME map
      const map = {};
      res.forEach(c => {
        map[c.id] = c.name;
      });

      this.categoryMap = map;

      // 🔹 Dropdown options (already correct)
      const categoryInput = this.extraInputs.find(x => x.model === "categories");
      categoryInput.options = res.map(c => ({
        label: c.name.toUpperCase(),
        value: c.id
      }));
    });
  },

  loadAllForExport() {
    const total = this.tableData.totalElements;

  if (!total || total <= 0) {
    this.allTableData = {
      content: [],
      totalElements: 0,
      totalPages: 0,
      currentPage: 0
    };
    return Promise.resolve();
  }


    // 🔹 Clone search model
    const exportParams = { ...this.searchModel };


  // ✅ FORMAT PHONE FOR BACKEND
  if (exportParams.phone) {
    let phoneStr = String(exportParams.phone).replace("+", "");

    if (phoneStr.startsWith(String(exportParams.phoneCode))) {
      phoneStr = phoneStr.substring(String(exportParams.phoneCode).length);
    }

    exportParams.phone = parseInt(
      String(exportParams.phoneCode) + phoneStr
    );
  }

  // ✅ FORMAT ALTERNATE PHONE
  if (exportParams.alternatePhone) {
    let altStr = String(exportParams.alternatePhone).replace("+", "");

    if (altStr.startsWith(String(exportParams.alternatePhoneCode))) {
      altStr = altStr.substring(String(exportParams.alternatePhoneCode).length);
    }

    exportParams.alternatePhone = parseInt(
      String(exportParams.alternatePhoneCode) + altStr
    );
  }

    // ❌ Remove pagination
    delete exportParams.page;
    delete exportParams.size;

    // ✅ Force full fetch
  exportParams.page = 1;


    exportParams.size = total;

    // 🔹 Normalize partnerCodes
    if (exportParams.partnerCodes) {
      exportParams.partnerCodes = Array.isArray(exportParams.partnerCodes)
        ? exportParams.partnerCodes
        : exportParams.partnerCodes
          .split(/[\n,]+/)
            .map(v => v.trim())
            .filter(Boolean);
    }

    // 🔹 Normalize languages
    if (!exportParams.languages || exportParams.languages.length === 0) {
      delete exportParams.languages;
    }

    const params = this.$root.addInstitutionId(exportParams);

    return this.$api
      .post("/institution/list-members", params)
      .then(res => {
        const data = res.data ?? res;const selectedSub = this.searchModel.subscription;
  const selectedCategories = this.searchModel.categories || [];

  const mapped = (data.content || [])
    .map((row, index) => {

      let entries = row.subscriptionsMap
        ? Object.entries(row.subscriptionsMap)
        : [];

      if (selectedCategories.length > 0) {
        entries = entries.filter(([k, v]) =>
          selectedCategories.includes(v.categoryId)
        );
      }

      if (selectedSub) {
        entries = entries.filter(([k, v]) =>
          v.subscription === selectedSub
        );
      }

      if (entries.length === 0) {
        return null;
      }

      const categories = entries.map(([k]) => k).join(", ");
      const subscriptions = entries.map(([k, v]) => v.subscription).join(", ");

      return {
        ...row,
        serialNo: index + 1,
        district: row.district ? row.district.toUpperCase() : "",
        email: row.email ? row.email.toUpperCase() : "",
        address1: row.addressLine1 ? row.addressLine1.toUpperCase() : "",
        address2: row.addressLine2 ? row.addressLine2.toUpperCase() : "",
        address3: row.addressLine3 ? row.addressLine3.toUpperCase() : "",
        categories: categories,
        subscription: subscriptions
      };

    })
    .filter(Boolean);

  this.allTableData = {
    content: mapped,
    totalElements: mapped.length,
    totalPages: 1,
    currentPage: 0
  };

      });
  },



  async checkExportStatus(jobId) {
    console.log("POLLING STARTED FOR JOB:", jobId);
    
    const interval = setInterval(async () => {
      try {
        const response = await this.$api.get(`/institution/export-status/${jobId}`);
        const job = response.data ?? response;

        console.log(`JOB ${jobId} STATUS:`, job.status);

        if (job.status === "COMPLETED") {
          clearInterval(interval);
          
          // 🔥 TRIGGER DOWNLOAD USING AXIOS
          this.$api({
            url: `/institution/download-export/${jobId}`,
            method: 'GET',
            responseType: 'blob', // 👈 Browser binary data read panna idhu must
          }).then((res) => {
            // IMPORTANT: Sila axios wrappers-la blob 'res.data'-la irukkum, siladhula direct-ah 'res'-la irukkum
            const blobData = res.data instanceof Blob ? res.data : (res instanceof Blob ? res : new Blob([res.data || res]));

            console.log("Download Success! File size:", blobData.size);

            if (blobData.size < 100) { 
              console.warn("Warning: Downloaded file is suspiciously small.");
            }

            const url = window.URL.createObjectURL(blobData);
            const link = document.createElement('a');
            link.href = url;
            
            // Use backend filename
            link.setAttribute('download', job.fileName || `PARTNER_REPORT_${jobId}.csv`); 
            
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$store.commit("setLoading", false);
            this.$toast.add({
              severity: "success",
              summary: "Export Completed",
              detail: "CSV Downloaded",
              life: 3000
            });
          }).catch(err => {
            this.$store.commit("setLoading", false);
            console.error("Download Error:", err);
          });
        }

        if (job.status === "FAILED") {
          clearInterval(interval);
          this.$store.commit("setLoading", false);
          this.$toast.add({
            severity: "error",
            summary: "Export Failed",
            detail: job.errorMessage || "Export failed",
            life: 5000
          });
        }

      } catch (e) {
        clearInterval(interval);
        this.$store.commit("setLoading", false);
        console.error("Polling Error:", e);
      }
    }, 3000); 
  },

  makeSearch(model) {

    const payload = { ...model };

    // ✅ FIX PHONE
    if (payload.phone) {
      let phoneStr = String(payload.phone).replace("+", "");

      if (phoneStr.startsWith(String(payload.phoneCode))) {
        phoneStr = phoneStr.substring(String(payload.phoneCode).length);
      }

      payload.phone = parseInt(String(payload.phoneCode) + phoneStr);
    }

    // ✅ FIX ALTERNATE PHONE
    if (payload.alternatePhone) {
      let altStr = String(payload.alternatePhone).replace("+", "");

      if (altStr.startsWith(String(payload.alternatePhoneCode))) {
        altStr = altStr.substring(String(payload.alternatePhoneCode).length);
      }

      payload.alternatePhone = parseInt(
        String(payload.alternatePhoneCode) + altStr
      );
    }

  // 🔹 FIX partnerCodes (support comma + newline)
  const originalPartnerCodes = model.partnerCodes;

  if (payload.partnerCodes && typeof payload.partnerCodes === "string") {
    payload.partnerCodes = payload.partnerCodes
      .split(/[\n,]+/)  
      .map(code => code.trim())
      .filter(code => code.length > 0);

      if (payload.partnerCodes.length > 200) {
      this.$toast.add({
        severity: "warn",
        summary: "Too Many Partner Codes",
        detail: "Maximum 200 Partner Codes allowed per search.",
        life: 4000
      });
      return;
    }



  } else {
    payload.partnerCodes = null;
  }

    this.searchModel = { ...model };
  // restore UI textbox value
  this.searchModel.partnerCodes = originalPartnerCodes;
    payload.page = 1;
    payload.isFilterSearch = true;

    // ✅ KEEP UI CLEAN


    // ✅ SEND FORMATTED DATA TO BACKEND


  //this.fetchAll(payload);

  this.fetchPage(payload)
  }
  ,

  //commanda date is 15/06/2026

/*
  loadPage(isNext, params) {
    this.searchModel.page = isNext
      ? this.searchModel.page + 1
      : this.searchModel.page - 1;

    this.searchModel.size = params.size || this.searchModel.size;

    this.fetchPage(this.searchModel);
  },
*/

//added date is 15/06/2026

loadPage(isNext, params) {

  this.searchModel.page = isNext
    ? this.searchModel.page + 1
    : this.searchModel.page - 1;

  this.searchModel.size = params.size || this.searchModel.size;

  // ✅ Convert partner codes again for pagination
  const payload = { ...this.searchModel };

  if (payload.partnerCodes && typeof payload.partnerCodes === "string") {
    payload.partnerCodes = payload.partnerCodes
      .split(/[\n,]+/)
      .map(code => code.trim())
      .filter(Boolean);
  }

  this.fetchPage(payload);
},

  fetchPage(params) {
    this.$store.commit("setLoading", true);

    const payload = this.$root.addInstitutionId({
      ...params,
      page: params.page || 1,
      size: params.size || 10
    });

    this.$api.post("/institution/list-members", payload)
      .then(res => {
        const data = res.data ?? res;

        const selectedSub = this.searchModel.subscription;
  const selectedCategories = this.searchModel.categories || [];

  const mapped = (data.content || [])
    .map((row, index) => {

      let entries = row.subscriptionsMap
        ? Object.entries(row.subscriptionsMap)
        : [];

      // ✅ category filter
      if (selectedCategories.length > 0) {
        entries = entries.filter(([k, v]) =>
          selectedCategories.includes(v.categoryId)
        );
      }

      // ✅ subscription filter
      if (selectedSub) {
        entries = entries.filter(([k, v]) =>
          v.subscription === selectedSub
        );
      }

      // ❌ if no matching data → remove row
      if (entries.length === 0) return null;

      const categories = entries.map(([k]) => k).join(", ");
      const subscriptions = entries.map(([k, v]) => v.subscription).join(", ");

      return {
        ...row,
        categories,
        subscription: subscriptions,
        serialNo: (data.currentPage - 1) * (payload.size) + index + 1
      };
    })
    .filter(Boolean);

        this.tableData = {
          content: mapped,
          totalElements: data.totalElements,
          totalPages: data.totalPages,
          currentPage: data.currentPage
        };

        this.$store.commit("setLoading", false);
      })
      .catch(err => {
        this.$root.handleApiError(err, "Partner Report");
        this.$store.commit("setLoading", false);
      });
  },

  logReportAction(action) {
    if (!this.institution) return;

    this.$api.post("/institution/report-action", {
      action: action,                
      institutionId: this.institution.id
    }).catch(() => {
    
    });
  },

  validateSelectedFields() {

  if (!this.selectedFields || this.selectedFields.length === 0) {

    this.$toast.add({
      severity: "warn",
      summary: "Validation",
      detail: "Please select at least one report field.",
      life: 3000
    });

    return false;
  }

  return true;
},






  async exportExcel() {
  if (!this.validateSelectedFields()) {
    return;
  }

    this.logReportAction("PARTNER_REPORT_EXCEL");
    this.$store.commit("setLoading", true); // Loader start

    try {

      // added date is 10/06/2026
let partnerCodes = this.searchModel.partnerCodes;

if (partnerCodes && typeof partnerCodes === "string") {
  partnerCodes = partnerCodes
    .split(/[\n,]+/)
    .map(code => code.trim())
    .filter(Boolean);
}


      const payload = {
  ...this.searchModel,
  partnerCodes,
  institutionId: this.institution.id,
  selectedFields: this.selectedFields,
  isExport: true
};

      console.log("TRIGGERING EXPORT WITH PAYLOAD:", payload);

      const response = await this.$api.post(
        "/institution/export-members-excel",
        payload
      );

      // ✅ Response structure-a handle pandrom
      const resData = response.data ?? response;
      const jobId = resData.object;

      if (jobId) {
        console.log("SUCCESS: Job ID received ->", jobId);
        // 🔥 START POLLING IMMEDIATELY
        this.checkExportStatus(jobId);
      } else {
        this.$store.commit("setLoading", false);
        alert("Job ID not received from server");
      }

    } catch (e) {
      this.$store.commit("setLoading", false);
      this.$root.handleApiError(e, "Export Failed");
    }
  },

  /*
  async makePdf() {
    this.logReportAction("PARTNER_REPORT_PDF");

    this.$store.commit("setLoading", true);

    await this.loadAllForExport();   // 🔥 IMPORTANT

    this.$nextTick(() => {
      this.$nextTick(() => {
        this.downloadAsPDF();
        this.$store.commit("setLoading", false);
      });
    });
  },
  */

  async makePdf() {

      if (!this.validateSelectedFields()) {
    return;
  }

    this.logReportAction("PARTNER_REPORT_PDF");

    this.$store.commit("setLoading", true);

    try {

      //added date is 10/06/2026
      let partnerCodes = this.searchModel.partnerCodes;

if (partnerCodes && typeof partnerCodes === "string") {
  partnerCodes = partnerCodes
    .split(/[\n,]+/)
    .map(code => code.trim())
    .filter(Boolean);
}

      const payload = {
  ...this.searchModel,
  partnerCodes,
  institutionId: this.institution.id,
  selectedFields: this.selectedFields,
  isExport: true
};

      console.log(
        "TRIGGERING PDF EXPORT:",
        payload
      );

      const response = await this.$api.post(
        "/institution/export-members-pdf",
        payload
      );

      const resData = response.data ?? response;

      const jobId = resData.object;

      if (jobId) {

        console.log(
          "PDF JOB ID:",
          jobId
        );

        this.checkExportStatus(jobId);

      } else {

        this.$store.commit("setLoading", false);

        alert("Job ID not received");
      }

    } catch (e) {

      this.$store.commit("setLoading", false);

      this.$root.handleApiError(
        e,
        "PDF Export Failed"
      );
    }
  },

  downloadAsPDF() {

    const element = document.getElementById(this.reportPageId);
    if (!element) return;

    const date = this.getTodayForFileName();

    // ⭐ Detect if user selected ALL subscription
  const manyFields = this.selectedFields.length > 8;
  const pageOrientation = manyFields ? "A4 landscape" : "A4 portrait";

    element.style.display = "block";
    const content = element.outerHTML;
    element.style.display = "none";

  let disp_setting="toolbar=yes,location=no,";
  disp_setting+="directories=yes,menubar=yes,";
  disp_setting+="scrollbars=yes,width=650,height=600,left=100,top=25";

  let docprint = window.open("","",disp_setting);

  if(!docprint){
    alert("Please allow popups for PDF");
    return;
  }

  docprint.document.open();

  
    docprint.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>PARTNER_REPORT_${date}</title>

      <style>

  @page {
    size: ${pageOrientation};
    margin: 8mm;
  }

  body {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  table {
    width: 100% !important;
    border-collapse: collapse;
    margin: 0;
    font-family: Arial, Verdana, Geneva, sans-serif;
    font-size: 10px;
  table-layout: auto;
    text-transform: uppercase;
  }

  th {
    border: 1px solid #444;
    padding: 5px;
    text-align: left;
    font-weight: bold;
  }

  td {
    border: 1px solid #444;
    padding: 5px;
  }

  tr {
    page-break-inside: avoid;
  }

  </style>

    </head>

    <body onload="window.print(); window.close();">
      ${content}
    </body>
    </html>
    `);

    docprint.document.close();
  docprint.focus();
  }

  },


          mounted() {
          this.loadCategories();
            this.fetchPage(this.searchModel); 
      },

      }
      </script>

      <style scoped>

  /* Increase font size of Select Report Fields */
  .form-check-label{
    font-size:20px;
    font-weight:500;
  }

  /* Increase checkbox size */
  .form-check-input{
    transform: scale(1.25);
    margin-right:6px;
  }

  /* Increase title size */
  h5{
    font-size:18px;
  }
  

  </style>
